<script setup lang="ts">
import { useGetMe } from "@/auth/useMe";
import HandleQueryStatus from "@/components/HandleQueryStatus.vue";
import ConversationItem from "@/conversations/ConversationItem.vue";
import {
  useDeleteContactConversation,
  useGetContactConversations,
  useUpdateContactConversation,
} from "@/conversations/useContactConversations";
import type { ContactQuery } from "./types";

const { contactDetails } = defineProps<{ contactDetails: ContactQuery }>();

const { conversations, getContactConversationsStatus } =
  useGetContactConversations(contactDetails.id);
const { updateConversation } = useUpdateContactConversation(contactDetails.id);
const {
  deleteConversation,
  deleteContactConversationStatus,
  resetDeleteContactConversation,
} = useDeleteContactConversation(contactDetails.id);

const { me, getMeStatus } = useGetMe();
</script>

<template>
  <HandleQueryStatus :query-status="getContactConversationsStatus">
    <div class="box column column-lg container container-md">
      <HandleQueryStatus :query-status="getMeStatus">
        <template v-if="conversations.length > 0">
          <ConversationItem
            v-for="conversation in conversations"
            :key="conversation.id"
            :conversation="conversation"
            :me="me"
            :deleting-status="deleteContactConversationStatus"
            @initiate-delete="resetDeleteContactConversation"
            @delete="deleteConversation"
            @update="updateConversation"
          />
        </template>
        <p v-else>Für diesen Kontakt wurden noch keine Gespräche hinterlegt.</p>
      </HandleQueryStatus>
    </div>
  </HandleQueryStatus>
</template>
